import dialogs from './registered-dialogs';

const registerDialog = (modalType, Component) => {
  dialogs.set(modalType, Component);
};

export default registerDialog;
